// extracted by mini-css-extract-plugin
export default {"fakeMarkerWrapper":"customMarker_fakeMarkerWrapper__9gZYI","fakeMarker":"customMarker_fakeMarker__MTxJ1","shadow":"customMarker_shadow__5wQYM"};